// cancelShopping.js
'use strict';
import removeModals from '../action/removeModals.js';
import { addvalue } from '../resource/modalId.js';
import trackEvent, { SHOP_CLOSED } from '../resource/trackEvent.js';
import { SHOP_ID, ProductType } from '../resource/shopConstants.js';
import {
  SET_LIST_ITEMS,
  REMOVE_OPERATION_DATA,
  MERGE_OPERATION_DATA,
} from '../ActionTypes.js';

export const addvalueModalIds = [
  addvalue.DIAMOND_PACK_SELECTOR,
  addvalue.CURRENCY_SELECTOR,
  addvalue.ORDER_SUMMARY,
  addvalue.PAYMENT_SOURCE_SELECTOR,
  addvalue.CONFIRM_ORDER_EMAIL_INPUT,
  addvalue.TAPPAY_CARD_FORM,
  addvalue.ORDER_COMPLETE_ALERT,
  addvalue.ORDER_PROCESSING_ALERT,
];

/**
 * Cancel shopping
 * @kind action
 * @param {string} {shopId} - action param.
 * @return {Promise} Action promise.
 */
const cancelShopping =
  ({ shopId }) =>
  async dispatch => {
    trackEvent({
      type: SHOP_CLOSED,
      payload: {
        type:
          SHOP_ID.subscription === shopId
            ? ProductType.SUBSCRIPTIONS
            : ProductType.DIAMONDS,
      },
    });

    const selectPath = ['shop', shopId];
    const modalIds = SHOP_ID.addvalue === shopId ? addvalueModalIds : [];

    await dispatch(
      removeModals({
        ids: modalIds,
        transitionStatus: 'closing',
      })
    );
    dispatch({ type: REMOVE_OPERATION_DATA, payload: { selectPath } });
    dispatch({
      type: SET_LIST_ITEMS,
      payload: {
        selectPath: ['shop', shopId, 'products'],
        itemIds: [],
      },
    });
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['shop'],
        data: {
          usingShopId: undefined,
        },
      },
    });
  };

export default cancelShopping;
